import { Chip } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

export const multiChipStyles = makeStyles()(theme => ({
  chip: {
    '& .MuiChip-label': {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
    fontSize: '13px',
    lineHeight: '20px',
    fontWeight: 600,
    borderRadius: '20px',
    maxWidth: 100,
    cursor: 'pointer',
    height: '27px',
    width: '110px',
  },
}));

export const NewChip = ({ label, selected, chipIndex }: { label: string; selected?: number; chipIndex?: number }) => {
  const { classes } = multiChipStyles();
  chipIndex = chipIndex + 1;
  return (
    <React.Fragment>
      <Chip
        label={label}
        variant="outlined"
        className={classes.chip}
        style={{
          color: '#10a3de',
          backgroundColor: '#cee3eb',
          border: '2px solid #10a3de',
          paddingRight: selected > chipIndex ? '69px' : '',
          paddingLeft: chipIndex > selected ? '69px' : '',
        }}
      />
    </React.Fragment>
  );
};
